var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "118px",
    viewBox: "0 0 86 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TWDB-Admin-Tool",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(0.500000, 0.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-copy",
    transform: "translate(42.500000, 47.000000) rotate(-90.000000) translate(-42.500000, -47.000000) translate(-4.000000, 10.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1421358,0.372624131 L46.627417,8.85786438 C47.0179413,9.24838867 47.0179413,9.88155365 46.627417,10.2720779 L26.8986242,29.9990928 L92,30 C92.5128358,30 92.9355072,30.3860402 92.9932723,30.8833789 L93,31 L93,43 C93,43.5522847 92.5522847,44 92,44 L26.8986242,43.9990928 L46.627417,63.7279221 C46.987901,64.088406 47.0156305,64.6556371 46.7106056,65.0479283 L46.627417,65.1421356 L38.1376869,73.6318657 C37.7489043,74.0206483 37.1191787,74.0226355 36.7279501,73.6363143 L0.645002969,38.0059706 C0.630873553,37.9920184 0.617162847,37.9776485 0.603889088,37.9628799 C0.234706253,37.5521215 0.268409924,36.9198542 0.679168344,36.5506713 L4.40062418,33.2050928 L36.7279632,0.38338922 C37.1155035,-0.0100964547 37.7486501,-0.0149161489 38.1421358,0.372624131 Z",
    id: "arrow"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.5,
    y: 103.5,
    width: 84,
    height: 13,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download_white.ab59f06a18cabb6d6dc83b9da0f9ce59.svg";
export { ForwardRef as ReactComponent };